/* ========================================
   GSAP ANIMATIONS + SCROLLTRIGGER
   Ultra smooth, elegant reveals
   ======================================== */

document.addEventListener('DOMContentLoaded', function() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP not loaded, skipping animations');
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  initHeroParallax();
  initSectionReveals();
  initCollectionCards();
  initPillarCards();
  initFAQAccordion();
  initProductCardHover();
  initStaggerItems();
  initTextReveal();
  initImageParallax();
  initFloatingElements();
  initMagneticButtons();
  initWelcomeText();
  initLiquidGlassShimmer();
  initBreathingElements();
  initScrollTiltCards();
  initMountainDrift();
  initGlobalMountainsParallax();

  /* NEW v2 animations */
  initHeroTypewriter();
  initNavMagnetic();
  initIconMagnetic();
  initLogoFloat();
  initScrollProgress();
  initCardFlipEntrance();
  initBlobMorph();
  initParallaxText();
});

/* ---------- Hero Parallax ---------- */
function initHeroParallax() {
  const hero = document.querySelector('.hero-chainzoku');
  if (!hero) return;

  const bg = hero.querySelector('.hero-chainzoku__bg');
  const product = hero.querySelector('.hero-chainzoku__product-image');
  const content = hero.querySelector('.hero-chainzoku__content');

  if (bg) {
    gsap.to(bg, {
      yPercent: 20,
      ease: 'none',
      scrollTrigger: {
        trigger: hero,
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }
    });
  }

  if (product) {
    gsap.from(product, {
      y: 100,
      opacity: 0,
      scale: 0.85,
      duration: 1.6,
      ease: 'power4.out',
      delay: 0.2
    });
  }

  if (content) {
    gsap.from(content.children, {
      y: 60,
      opacity: 0,
      duration: 1.2,
      stagger: 0.2,
      ease: 'power3.out',
      delay: 0.6
    });
  }
}

/* ---------- Section Reveals (scroll trigger) ---------- */
function initSectionReveals() {
  const revealSections = document.querySelectorAll('[data-reveal]');

  revealSections.forEach(section => {
    gsap.fromTo(section,
      { y: 80, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: section,
          start: 'top 88%',
          toggleActions: 'play none none none'
        }
      }
    );
  });
}

/* ---------- Collection Cards Stagger ---------- */
function initCollectionCards() {
  const grids = document.querySelectorAll('[data-collection-grid]');

  grids.forEach(grid => {
    const cards = grid.querySelectorAll('[data-collection-card]');
    if (!cards.length) return;

    gsap.fromTo(cards,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        stagger: 0.15,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: grid,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      }
    );
  });
}

/* ---------- Pillar / Multicolumn Cards ---------- */
function initPillarCards() {
  const pillars = document.querySelectorAll('[data-pillar]');

  pillars.forEach((pillar, index) => {
    gsap.fromTo(pillar,
      { y: 60, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.8,
        delay: index * 0.12,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: pillar,
          start: 'top 88%',
          toggleActions: 'play none none none'
        }
      }
    );
  });
}

/* ---------- FAQ Accordion Animation ---------- */
function initFAQAccordion() {
  const accordions = document.querySelectorAll('[data-accordion]');

  accordions.forEach(accordion => {
    const triggers = accordion.querySelectorAll('[data-accordion-trigger]');

    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('[data-accordion-item]');
        const content = item.querySelector('[data-accordion-content]');
        const isOpen = item.hasAttribute('open');

        if (accordion.hasAttribute('data-single')) {
          accordion.querySelectorAll('[data-accordion-item][open]').forEach(openItem => {
            if (openItem !== item) {
              openItem.removeAttribute('open');
              const openContent = openItem.querySelector('[data-accordion-content]');
              gsap.to(openContent, { height: 0, duration: 0.4, ease: 'power3.inOut' });
            }
          });
        }

        if (isOpen) {
          item.removeAttribute('open');
          gsap.to(content, { height: 0, duration: 0.4, ease: 'power3.inOut' });
        } else {
          item.setAttribute('open', '');
          gsap.set(content, { height: 'auto' });
          const fullHeight = content.offsetHeight;
          gsap.fromTo(content, { height: 0 }, { height: fullHeight, duration: 0.5, ease: 'power3.out' });
        }
      });
    });
  });
}

/* ---------- Product Card Hover ---------- */
function initProductCardHover() {
  document.querySelectorAll('[data-product-card]').forEach(card => {
    const image = card.querySelector('img');
    if (!image) return;

    card.addEventListener('mouseenter', () => {
      gsap.to(image, { scale: 1.1, duration: 0.6, ease: 'power2.out' });
    });

    card.addEventListener('mouseleave', () => {
      gsap.to(image, { scale: 1, duration: 0.6, ease: 'power2.out' });
    });
  });
}

/* ---------- Stagger Items (generic) ---------- */
function initStaggerItems() {
  const staggerContainers = document.querySelectorAll('[data-stagger]');

  staggerContainers.forEach(container => {
    const items = container.children;
    gsap.fromTo(items,
      { y: 40, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.8,
        stagger: 0.12,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: container,
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      }
    );
  });
}

/* ---------- Text Character Reveal ---------- */
function initTextReveal() {
  const headings = document.querySelectorAll('.font-display');

  headings.forEach(heading => {
    gsap.fromTo(heading,
      { y: 40, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: heading,
          start: 'top 90%',
          toggleActions: 'play none none none'
        }
      }
    );
  });
}

/* ---------- Image Parallax on Scroll ---------- */
function initImageParallax() {
  document.querySelectorAll('.promo-block__image-wrapper img, .featured-product__image-wrapper img').forEach(img => {
    gsap.to(img, {
      yPercent: -8,
      ease: 'none',
      scrollTrigger: {
        trigger: img.closest('section'),
        start: 'top bottom',
        end: 'bottom top',
        scrub: true
      }
    });
  });
}

/* ---------- Floating Elements ---------- */
function initFloatingElements() {
  document.querySelectorAll('.float-gentle').forEach(el => {
    gsap.to(el, {
      y: -20,
      rotation: 3,
      duration: 4,
      repeat: -1,
      yoyo: true,
      ease: 'sine.inOut'
    });
  });
}

/* ---------- Magnetic Buttons ---------- */
function initMagneticButtons() {
  if (window.matchMedia('(pointer: coarse)').matches) return;

  document.querySelectorAll('.btn').forEach(btn => {
    btn.addEventListener('mousemove', (e) => {
      const rect = btn.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;

      gsap.to(btn, {
        x: x * 0.15,
        y: y * 0.15,
        duration: 0.3,
        ease: 'power2.out'
      });
    });

    btn.addEventListener('mouseleave', () => {
      gsap.to(btn, {
        x: 0,
        y: 0,
        duration: 0.5,
        ease: 'elastic.out(1, 0.5)'
      });
    });
  });
}

/* ---------- Welcome text animation ---------- */
function initWelcomeText() {
  const welcome = document.querySelector('.hero-chainzoku__welcome');
  if (!welcome || typeof gsap === 'undefined') return;

  gsap.from(welcome, {
    y: 30,
    opacity: 0,
    duration: 1.2,
    ease: 'power3.out',
    delay: 0.2
  });

  // Subtle continuous pulse on the welcome text
  gsap.to(welcome, {
    letterSpacing: '0.08em',
    duration: 3,
    repeat: -1,
    yoyo: true,
    ease: 'sine.inOut'
  });
}

/* ---------- Liquid glass shimmer on scroll ---------- */
function initLiquidGlassShimmer() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  document.querySelectorAll('.liquid-glass').forEach(el => {
    gsap.fromTo(el, {
      backgroundPosition: '0% 0%'
    }, {
      backgroundPosition: '100% 100%',
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true
      }
    });
  });
}

/* ---------- Breathing scale elements ---------- */
function initBreathingElements() {
  if (typeof gsap === 'undefined') return;

  document.querySelectorAll('.hero-chainzoku__product-image, .featured-product__image-wrapper').forEach(el => {
    gsap.to(el, {
      scale: 1.02,
      duration: 4,
      repeat: -1,
      yoyo: true,
      ease: 'sine.inOut'
    });
  });
}

/* ---------- Scroll tilt for cards ---------- */
function initScrollTiltCards() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  document.querySelectorAll('.product-card, .faction-card, .pillar-card').forEach(card => {
    gsap.fromTo(card,
      { rotateX: 8, y: 60, opacity: 0 },
      {
        rotateX: 0,
        y: 0,
        opacity: 1,
        duration: 0.9,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: card,
          start: 'top 90%',
          toggleActions: 'play none none none'
        }
      }
    );
  });
}

/* ---------- Mountain drift speed on scroll ---------- */
function initMountainDrift() {
  const mountains = document.querySelector('.hero-mountains');
  if (!mountains) return;

  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY || window.pageYOffset;
    const speed = 1 + (scrollY * 0.0005);
    mountains.style.setProperty('--mountain-speed', speed);
  }, { passive: true });
}

/* ---------- Global Mountains Parallax - EXTREME ---------- */
function initGlobalMountainsParallax() {
  const globalMountains = document.querySelector('.global-mountains');
  if (!globalMountains || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  const layers = globalMountains.querySelectorAll('.global-mountains__layer');

  layers.forEach((layer, index) => {
    // Much more aggressive parallax speeds
    const speedY = (index + 1) * 0.45;
    const speedX = (index + 1) * 0.12;
    const direction = index % 2 === 0 ? 1 : -1;

    gsap.to(layer, {
      y: () => -(window.innerHeight * speedY) * direction,
      x: () => (window.innerWidth * speedX) * direction,
      ease: 'none',
      scrollTrigger: {
        trigger: document.body,
        start: 'top top',
        end: 'bottom bottom',
        scrub: true
      }
    });

    // Layer-specific scale breathing for extra life
    gsap.to(layer, {
      scale: 1 + (index * 0.02),
      duration: 4 + index,
      repeat: -1,
      yoyo: true,
      ease: 'sine.inOut'
    });
  });

  // Dramatic horizontal drift on scroll
  globalMountains.querySelectorAll('.global-mountains__svg').forEach((svg, index) => {
    gsap.to(svg, {
      xPercent: index % 2 === 0 ? -8 : 8,
      ease: 'none',
      scrollTrigger: {
        trigger: document.body,
        start: 'top top',
        end: 'bottom bottom',
        scrub: true
      }
    });
  });
}

/* ---------- Smooth scroll for anchor links ---------- */
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const targetId = this.getAttribute('href');
    if (targetId === '#') return;
    const target = document.querySelector(targetId);
    if (target) {
      e.preventDefault();
      const y = target.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  });
});

/* ---------- NEW v2: Hero Typewriter Effect ---------- */
function initHeroTypewriter() {
  const title = document.querySelector('.hero-chainzoku__title');
  if (!title || typeof gsap === 'undefined') return;

  const text = title.textContent.trim();
  title.textContent = '';
  title.style.opacity = 1;

  const chars = text.split('');
  chars.forEach((char, i) => {
    const span = document.createElement('span');
    span.textContent = char;
    span.style.opacity = '0';
    span.style.display = 'inline-block';
    title.appendChild(span);

    gsap.to(span, {
      opacity: 1,
      y: 0,
      duration: 0.05,
      delay: 0.8 + (i * 0.04),
      ease: 'power2.out',
      from: { y: 10 }
    });
  });
}

/* ---------- NEW v2: Magnetic Nav Links ---------- */
function initNavMagnetic() {
  if (window.matchMedia('(pointer: coarse)').matches) return;

  document.querySelectorAll('.header-nav__link').forEach(link => {
    link.addEventListener('mousemove', (e) => {
      const rect = link.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      gsap.to(link, { x: x * 0.15, y: y * 0.15, duration: 0.3, ease: 'power2.out' });
    });
    link.addEventListener('mouseleave', () => {
      gsap.to(link, { x: 0, y: 0, duration: 0.5, ease: 'elastic.out(1, 0.5)' });
    });
  });
}

/* ---------- NEW v2: Magnetic Icons ---------- */
function initIconMagnetic() {
  if (window.matchMedia('(pointer: coarse)').matches) return;

  document.querySelectorAll('[data-magnetic-icon]').forEach(icon => {
    icon.addEventListener('mousemove', (e) => {
      const rect = icon.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      gsap.to(icon, { x: x * 0.25, y: y * 0.25, duration: 0.3, ease: 'power2.out' });
      gsap.to(icon.querySelector('svg'), { scale: 1.15, duration: 0.3, ease: 'power2.out' });
    });
    icon.addEventListener('mouseleave', () => {
      gsap.to(icon, { x: 0, y: 0, duration: 0.5, ease: 'elastic.out(1, 0.5)' });
      gsap.to(icon.querySelector('svg'), { scale: 1, duration: 0.4, ease: 'power2.out' });
    });
  });
}

/* ---------- NEW v2: Logo Float ---------- */
function initLogoFloat() {
  const logo = document.querySelector('[data-header-logo]');
  if (!logo || typeof gsap === 'undefined') return;

  gsap.to(logo, {
    y: -4,
    duration: 3,
    repeat: -1,
    yoyo: true,
    ease: 'sine.inOut'
  });
}

/* ---------- NEW v2: Scroll Progress Bar ---------- */
function initScrollProgress() {
  const bar = document.createElement('div');
  bar.className = 'scroll-progress-bar';
  bar.style.cssText = 'position:fixed;top:0;left:0;height:2px;background:linear-gradient(90deg,var(--color-coral),var(--color-mint));z-index:9999;transform-origin:left;transform:scaleX(0);will-change:transform;pointer-events:none;';
  document.body.appendChild(bar);

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.to(bar, {
      scaleX: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: document.body,
        start: 'top top',
        end: 'bottom bottom',
        scrub: true
      }
    });
  }
}

/* ---------- NEW v2: Card Flip Entrance ---------- */
function initCardFlipEntrance() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  document.querySelectorAll('.product-card, .collection-card').forEach((card, index) => {
    gsap.fromTo(card,
      { rotateY: 15, opacity: 0, y: 60 },
      {
        rotateY: 0,
        opacity: 1,
        y: 0,
        duration: 0.9,
        delay: (index % 3) * 0.1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: card,
          start: 'top 92%',
          toggleActions: 'play none none none'
        }
      }
    );
  });
}

/* ---------- NEW v2: Blob Morph (hero shapes) ---------- */
function initBlobMorph() {
  if (typeof gsap === 'undefined') return;

  document.querySelectorAll('.hero-shape').forEach((shape, i) => {
    gsap.to(shape, {
      borderRadius: `${40 + i * 5}% ${60 - i * 5}% ${50 + i * 3}% ${50 - i * 3}% / ${50 - i * 4}% ${40 + i * 6}% ${60 - i * 3}% ${50 + i * 2}%`,
      duration: 6 + i,
      repeat: -1,
      yoyo: true,
      ease: 'sine.inOut'
    });
  });
}

/* ---------- NEW v2: Parallax Text for headings ---------- */
function initParallaxText() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  document.querySelectorAll('h2, .section-title').forEach(heading => {
    gsap.fromTo(heading,
      { x: -40, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: heading,
          start: 'top 90%',
          toggleActions: 'play none none none'
        }
      }
    );
  });
}

/* ---------- Scroll progress indicator (subtle, no header distortion) ---------- */
let lastScrollTop = 0;
let ticking = false;

window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      lastScrollTop = st;
      ticking = false;
    });
    ticking = true;
  }
}, { passive: true });
